const Title = ({ text }) => {
  const base =
    'text-displayMobile md:text-displayDesktop text-olive text-center md:text-left font-ttDrugsTrial'

  return <span className={base}>{text}</span>
}

export default Title
